import React from 'react';
import { usePlatformUsdRates } from '../hooks/usePlatformUsdRates';
import { formatCryptoAmount, formatUsd } from '../utils/cryptoUsd';

interface CryptoAmountWithUsdProps {
  units: number;
  currency: string;
  showCurrency?: boolean;
  className?: string;
  usdClassName?: string;
  /** When provided, skips live rate conversion and uses this value. */
  usdValue?: number | null;
}

const CryptoAmountWithUsd: React.FC<CryptoAmountWithUsdProps> = ({
  units,
  currency,
  showCurrency = true,
  className,
  usdClassName = 'text-slate-500 text-xs',
  usdValue,
}) => {
  const { toUsdUnits, isLoading } = usePlatformUsdRates();
  const usd = usdValue ?? toUsdUnits(units, currency);

  return (
    <span className={className}>
      {formatCryptoAmount(units)}
      {showCurrency && <span className="text-slate-500"> {currency}</span>}
      {!isLoading && usd != null && (
        <span className={usdClassName}> ({formatUsd(usd)})</span>
      )}
    </span>
  );
};

export default CryptoAmountWithUsd;
